export const API_SUCCESS = "API_SUCCESS";
export const API_FAIL = "API_FAIL";
export const GET_STATISTICS_DATA = "GET_STATISTICS_DATA";
